import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingIndicator } from "../progress/loading-indicator/LoadingIndicator";
import { LoadingWrapper } from "./MenuListItem.styled";
export const LoadingMenuListItem = () => (_jsx(LoadingWrapper, { children: _jsx(LoadingIndicator, {}) }));
